import { create } from 'zustand';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface Toast {
  id: string;
  message: string;
  type: 'success' | 'error' | 'warning' | 'info';
  action?: ToastAction;
}

interface ToastOptions {
  durationMs?: number;
  action?: ToastAction;
}

interface ToastStore {
  toasts: Toast[];
  addToast: (message: string, type: Toast['type'], options?: ToastOptions) => void;
  removeToast: (id: string) => void;
}

let toastIdCounter = 0;

export const useToastStore = create<ToastStore>((set, get) => ({
  toasts: [],
  addToast: (message, type, options) => {
    const id = `toast-${Date.now()}-${++toastIdCounter}`;
    const duration = options?.durationMs ?? 5000;
    set((state) => ({
      toasts: [...state.toasts, { id, message, type, action: options?.action }],
    }));
    setTimeout(() => {
      const currentToasts = get().toasts;
      if (currentToasts.some((t) => t.id === id)) {
        set((state) => ({
          toasts: state.toasts.filter((t) => t.id !== id),
        }));
      }
    }, duration);
  },
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
}));
